import { Form } from 'antd';
import { useEffect, useContext } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import Loading from '@/components/Loading';
import styles from './edit.less?modules';
import { useSelector, useDispatch } from 'dva';
import { FunctionContext } from '../../../index';
import { message } from 'antd';
const Edit = (props) => {
  const [form] = Form.useForm();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dvm/addDiagram'];
  const { singleListInfo, handleCancel } = props;
  const { fetchData } = useContext(FunctionContext);
  const editSingleDiagram = (value, id) => {
    dispatch({
      type: 'dvm/updateDiagramVersionAudit',
      payload: {
        id,
        values: {
          ...value,
        },
      },
      callback: () => {
        message.success('编辑成功');
        fetchData();
        handleCancel();
      },
    });
  };
  const dispatch = useDispatch();
  // 发起请求
  const onFinish = (values) => {
    editSingleDiagram(values, singleListInfo && singleListInfo.id);
  };

  useEffect(() => {
    if (!singleListInfo) {
      return;
    }
    let newData = {};
    newData['description'] = singleListInfo['versionDescription'];
    form.setFieldsValue({
      ...newData,
    });
  }, [form, singleListInfo]);
  console.log(singleListInfo);
  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 手机号码 */}
          <InputML
            labelVal="描述"
            placeVal="请输入描述"
            name="description"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入描述',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            // htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default Edit;
